import React, { FC } from "react";
import { IconButton, ListActionButtonProps } from "sprint-common-web";

type EditListButtonProps = Pick<ListActionButtonProps, "disabled" | "onClick">;

export const EditListButton: FC<EditListButtonProps> = (props: EditListButtonProps) => {
    return (
        <IconButton
            tooltipContent="Edit"
            iconProps={{ iconName: "EditSolid12" }}
            disabled={props.disabled}
            onClick={props.onClick}
        />
    );
};
